import { RealtimeSpread } from '@/pages/RealtimeSpread';

export function OppSpreadLive() {
  return (
    <RealtimeSpread historySource="opp-detector" chartMode="spread-price" />
  );
}
